import React, { useState, useEffect } from 'react';
import { Container, Alert, Button } from "react-bootstrap";
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';


export default function SurveyPlayer({ episode }) {

    const [data, setData] = useState(null);
    const [errors, setErrors] = useState('');


    useEffect(() => {
        init()
    }, [episode]);


    async function init() {
        if (episode && episode.idSurvey) {
            var response = await DataManager.getItem('episode_live', episode.idSurvey)
            console.warn('episode_survey', response)
            if (response.success === 1) {
                let b = response.body[0]
                console.log(b)
                setData(b)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
            }
        }
    }


    async function openSurvey(item) {
        /*
            COMPLETO EPISODIO AL CLICK!
        */
        window.open(item.link, '_blank'); // mando utente a link del questionario
    }



    if (data !== null) {
        

        return (
            <>
                {errors.length > 0 &&
                    <Alert variant='danger mt-5'>
                        {errors}
                    </Alert>
                }


                <Container fluid='md' className='text-center' style={{'maxWidth': 400}}>
                    <h3>Questionario: {episode.name}</h3>
                    <Button onClick={() => openSurvey(data)} size='lg' className='mt-4 w-100'>Inizia questionario</Button>
                </Container>
            </>
        );
    }
};